import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ArqSiopeService } from './arq-siope.service';
import Swal from 'sweetalert';
import { LocalStorage } from 'src/app/service/classes/localstorage/LocalStorage';
import { Crypto } from 'src/app/service/classes/crypto/crypto';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-arq-siope',
  templateUrl: './arq-siope.component.html',
  styleUrls: ['./arq-siope.component.css'],
})
export class ArqSiopeComponent implements OnInit {
  formArquivoSiope: FormGroup;
  empfil: string;
  localStorage: LocalStorage;

  constructor(
    public fb: FormBuilder,
    private arqSiopeService: ArqSiopeService,
    private spinner: NgxSpinnerService
  ) {
    this.localStorage = this.decryptLocalStorage();
    this.empfil = this.localStorage.FilialAtual.toString();
  }

  decryptLocalStorage(): LocalStorage {
    if (localStorage.getItem('util') != null) {
      return JSON.parse(new Crypto().decryptUsingAES256(localStorage.getItem('util')));
    }
  }

  ngOnInit() {
    this.formArquivoSiope = this.fb.group({
      dtComp: ['', Validators.required],
    });
  }

  formatarDataCompInput(event: any) {
    let value = event.target.value.replace(/\D/g, '');
    if (value.length > 2) {
      value = value.substring(0, 2) + '/' + value.substring(2, 6);
    }
    event.target.value = value;
  }

  converterPeriodoParaFormatoAPI(periodo: string): string {
    if (!periodo) return '';

    const digitos = periodo.replace(/\D/g, '');

    const mes = digitos.substring(0, 2);
    const ano = digitos.substring(2, 6);

    return `${ano}${mes}`;
  }

  converterPeriodoParaDownload(periodo: string): string {
    if (!periodo) return '';

    const digitos = periodo.replace(/\D/g, '');

    const mes = digitos.substring(0, 2);
    const ano = digitos.substring(2, 6);

    return `${mes}-${ano}`;
  }


  gerarArquivo() {
    this.spinner.show();

    const periodo = this.formArquivoSiope.get('dtComp').value;
    if (!periodo) {
      this.spinner.hide();
      Swal('Erro', 'Por favor, informe a Data Competência', 'warning');
      return;
    }

    const dataFormatada = this.converterPeriodoParaFormatoAPI(periodo);
    const periodoDownload = this.converterPeriodoParaDownload(periodo);

    this.arqSiopeService.gerarArquivoSiope(this.empfil, dataFormatada).subscribe(
      (data: any) => {
        this.spinner.hide();

        const conteudo = atob(data.Base64);
        const blob = new Blob([conteudo], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download =  `SIOPE_${periodoDownload}.csv`;
        document.body.appendChild(a);
        a.click();

        setTimeout(() => {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }, 100);
      },
      (error) => {
        this.spinner.hide();
        console.error('Erro completo:', error);
        const mensagemErro = error.error?.Mensagem || 'Erro ao gerar arquivo CSV.';
        Swal('Erro', mensagemErro, 'error');
      }
    );
  }
}
